export default "__VITE_ASSET__5aac194e__"